import { useEffect } from 'react';
import { atom, useRecoilState, useSetRecoilState } from 'recoil';
import {
  CreateIngramDiscountRequest,
  CreateProgramRequest,
} from './ingramProgramsMutations';
import {
  IngramDiscount,
  IngramProgramDetailResponse,
} from './ingramProgramsSearch';

const IngramProgramFormAtom = atom<CreateProgramRequest>({
  default: {
    manualTemplatesFieldProperties: {
      vendorACOPDiscountType: 'CompanyWideDiscount',
    },
  },
  key: 'ingram-program-form',
});

const IngramProgramFormIsUpdatedAtom = atom<boolean>({
  default: false,
  key: 'ingram-program-form-is-updated',
});

export function useIsIngramProgramFormUpdated() {
  return useRecoilState(IngramProgramFormIsUpdatedAtom);
}

export function useIngramProgramForm(
  intialValue?: IngramProgramDetailResponse
) {
  const [fromData, _setFormData] = useRecoilState(IngramProgramFormAtom);
  const setIsFormUpdated = useSetRecoilState(IngramProgramFormIsUpdatedAtom);

  const setFormData = (formData: Parameters<typeof _setFormData>[0]) => {
    setIsFormUpdated(Boolean(formData));
    _setFormData(formData);
  };

  useEffect(() => {
    if (!intialValue) return;
    setIsFormUpdated(false);
    _setFormData(intialValue.ingramVendorProgramDetail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intialValue]);
  return [fromData, setFormData] as const;
}

const IngramProgramDiscountFormAtom = atom<
  CreateIngramDiscountRequest | undefined
>({
  default: undefined,
  key: 'ingram-program-discount-form',
});

const IngramProgramDiscountFormIsUpdatedAtom = atom<boolean>({
  default: false,
  key: 'ingram-program-discount-form-is-updated',
});

export function useIsIngramProgramDiscountFormUpdated() {
  return useRecoilState(IngramProgramDiscountFormIsUpdatedAtom);
}

export function useIngramProgramDiscountForm(intialValue?: IngramDiscount) {
  const [fromData, _setFormData] = useRecoilState(
    IngramProgramDiscountFormAtom
  );
  const setIsFormUpdated = useSetRecoilState(
    IngramProgramDiscountFormIsUpdatedAtom
  );

  const setFormData = (formData: Parameters<typeof _setFormData>[0]) => {
    setIsFormUpdated(Boolean(formData));
    _setFormData(formData);
  };

  useEffect(() => {
    if (!intialValue) return;
    const data: CreateIngramDiscountRequest = {
      ...intialValue,
      discount_amount: intialValue.discountAmount.toString(),
      discount_calc_type: intialValue.discountCalcType,
      discount_type: intialValue.discountType,
      effective_date: intialValue.effectiveDate,
      expiration_date: intialValue.expirationDate,
      program_id: intialValue.programId,
      status_code: intialValue.statusCode,
    };
    setIsFormUpdated(false);
    _setFormData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intialValue]);
  return [fromData ?? {}, setFormData] as const;
}
